import React, { useContext } from 'react'
import { SkyInformationPopover } from './SkyPopover'
var classNames = require('classnames')

export const BrokerIdentityCodePopover = ({ text }) => {
  return (
    <SkyInformationPopover eventId={'broker-identity-code'}>
      <div className="text-body margin-top-small">{text}</div>
    </SkyInformationPopover>
  )
}
